import { gql } from '@apollo/client';

export const UTILITY_FRAGMENT = gql`
  fragment UtilityData on Utility {
    id
    displayName
    funnelTrack
    forgotPassword
    registerForAccount
    state {
      abbreviation
      requireCommunicationPreference
      id
      name
    }
    fieldValidationRules {
      id
      fieldName
      fieldType
      helpText
      patterns
    }
  }
`;

export const FETCH_UTILITY = gql`
  query Flex_FetchUtility($utilityId: Int!) {
    utility(id: $utilityId) {
      ...UtilityData
    }
  }
  ${UTILITY_FRAGMENT}
`;
